import { render, staticRenderFns } from "./PrepaymentSettingsManagement.vue?vue&type=template&id=2c8318ca&"
import script from "./PrepaymentSettingsManagement.vue?vue&type=script&lang=js&"
export * from "./PrepaymentSettingsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports